import _ from 'lodash';
import { ADD_SECTION_DATA, INIT_DEVICE, SET_ACTIVE_SECTION, SET_BACKGROUND_IMAGE, TOGGLE_MENU, } from 'constants/ActionTypes';
// The device is deliberately unknown until the browser says so: the server used
// to derive it from the User-Agent, which made every render device-specific and
// therefore unshareable by any cache that does not key on User-Agent. Neutral
// here means "render for everyone" — both store links — and the client narrows it
// after hydration.
const NEUTRAL_DEVICE = { isMobile: false, isIOs: false, isAndroid: false };
const homeReducer = (state = { device: NEUTRAL_DEVICE }, action) => {
    switch (action.type) {
        case ADD_SECTION_DATA: {
            const sections = (state && state.sections) || {};
            const name = action.payload.name;
            sections[name] = Object.assign(Object.assign({}, sections[name]), action.payload);
            return Object.assign(Object.assign({}, state), { sections });
        }
        case SET_ACTIVE_SECTION: {
            const activeSection = state.activeSection;
            if (action.payload === activeSection) {
                return state;
            }
            else {
                return Object.assign(Object.assign({}, state), { activeSection: action.payload });
            }
        }
        case SET_BACKGROUND_IMAGE: {
            // TODO save backgroundId for every section separatly
            return Object.assign(Object.assign({}, state), { backgroundImageId: action.payload, prevBackgroundImageId: state.backgroundImageId });
        }
        case INIT_DEVICE: {
            const device = action.payload;
            return Object.assign(Object.assign({}, state), { device });
        }
        case TOGGLE_MENU: {
            const isMenuOpen = !_.get(state, 'isMenuOpen', false);
            // TODO remove side effect
            if (isMenuOpen) {
                document.body.classList.add('menuIsOpen');
            }
            else {
                document.body.classList.remove('menuIsOpen');
            }
            return Object.assign(Object.assign({}, state), { isMenuOpen });
        }
        default:
            return state;
    }
};
export default homeReducer;
